import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demand-survey-draft',
  templateUrl: './demand-survey-draft.component.html',
  styleUrls: ['./demand-survey-draft.component.css']
})
export class DemandSurveyDraftComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/demand-survey-draft/demand-survey-draft.component.ts